import React, { useState, useEffect } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { HashLink } from "react-router-hash-link";
import IconButton from "@mui/joy/IconButton";
import MenuIcon from "@mui/icons-material/Menu";
import CloseIcon from "@mui/icons-material/Close";
import logo from "../assets/logotipo.png";
import { menuItems } from "../helpers/menuItems";
import "../styles/Navbar.css";

function Navbar() {
  const [expandedNavbar, setExpandedNavbar] = useState(false);
  const [navbarState, setNavbarState] = useState("top");
  const [lastScrollY, setLastScrollY] = useState(0);
  const [activeSubmenu, setActiveSubmenu] = useState(null);
  const location = useLocation();
  const navigate = useNavigate();

  // Cerrar navbar al cambiar de ruta
  useEffect(() => {
    setExpandedNavbar(false);
    setActiveSubmenu(null);
  }, [location]);

  // Manejar el scroll
  useEffect(() => {
    const handleScroll = () => {
      const currentScrollY = window.scrollY;

      if (currentScrollY <= 10) {
        setNavbarState("top");
      } else if (currentScrollY > lastScrollY && currentScrollY > 10) {
        setNavbarState("hidden");
      } else {
        setNavbarState("visible");
      }

      setLastScrollY(currentScrollY);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, [lastScrollY]);

  const handleLogoClick = () => {
    navigate("/");
    setExpandedNavbar(false);
  };

  const toggleSubmenu = (index) => {
    setActiveSubmenu(activeSubmenu === index ? null : index);
  };

  const shouldShowNavbar = navbarState !== "hidden";

  return (
    <header className={`navbar ${navbarState}`}>
      {shouldShowNavbar && (
        <>
          {/* Overlay para mobile */}
          {expandedNavbar && (
            <div
              className="mobile-overlay open"
              onClick={() => setExpandedNavbar(false)}
            />
          )}

          <div className="navbar-container">
            <div onClick={handleLogoClick} className="logo-container">
              <img src={logo} alt="logo" className="logo" />
            </div>

            {/* Versión Desktop */}
            <div className="desktop-links">
              {menuItems.map((item, index) => (
                <div
                  key={`d-${index}`}
                  className="desktop-menu-item"
                  onMouseEnter={() =>
                    item.subItems.length > 0 && setActiveSubmenu(index)
                  }
                  onMouseLeave={() =>
                    item.subItems.length > 0 && setActiveSubmenu(null)
                  }
                >
                  {item.title === "Contacto" ? (
                    <HashLink smooth to="/#contacto" className="desktop-link">
                      {item.title}
                    </HashLink>
                  ) : item.subItems.length > 0 ? (
                    <HashLink to={item.path} className="desktop-link">
                      {item.title}
                      {item.subItems.length > 0 && (
                        <span className="arrow">▼</span>
                      )}
                    </HashLink>
                  ) : (
                    <Link to={item.path} className="desktop-link">
                      {item.title}
                    </Link>
                  )}

                  {/* Submenú Desktop */}
                  {item.subItems.length > 0 && activeSubmenu === index && (
                    <div
                      className="desktop-submenu"
                      onMouseEnter={() => setActiveSubmenu(index)}
                      onMouseLeave={() => setActiveSubmenu(null)}
                    >
                      {item.subItems.map((subItem, subIndex) => (
                        <HashLink
                          smooth
                          key={`d-sub-${subIndex}`}
                          to={subItem.path}
                          className="desktop-submenu-link"
                          onClick={() => setActiveSubmenu(null)}
                        >
                          {subItem.title}
                        </HashLink>
                      ))}
                    </div>
                  )}
                </div>
              ))}
            </div>

            {/* Versión Mobile - Botón de menú */}
            <div className="mobile-menu-button">
              <IconButton
                onClick={() => setExpandedNavbar(!expandedNavbar)}
                aria-label={expandedNavbar ? "Cerrar menú" : "Abrir menú"}
              >
                {expandedNavbar ? <CloseIcon /> : <MenuIcon />}
              </IconButton>
            </div>
          </div>

          {/* Menú móvil desplegable */}
          <div className={`mobile-links ${expandedNavbar ? "open" : ""}`}>
            {menuItems.map((item, index) => (
              <div key={`m-${index}`} className="mobile-menu-item">
                {item.title === "Contacto" ? (
                  <HashLink
                    smooth
                    to="/#contacto"
                    className="mobile-link"
                    onClick={() => setExpandedNavbar(false)}
                  >
                    {item.title}
                  </HashLink>
                ) : item.subItems.length > 0 ? (
                  <div className="mobile-menu-with-submenu">
                    <div
                      className="mobile-link-container"
                      onClick={() => toggleSubmenu(index)}
                    >
                      <span className="mobile-link">
                        {item.title}
                        <span
                          className={`arrow ${
                            activeSubmenu === index ? "rotate" : ""
                          }`}
                        >
                          ▼
                        </span>
                      </span>
                    </div>
                    <div
                      className={`mobile-submenu ${
                        activeSubmenu === index ? "open" : ""
                      }`}
                    >
                      {item.subItems.map((subItem, subIndex) => (
                        <HashLink
                          smooth
                          key={`m-sub-${subIndex}`}
                          to={subItem.path}
                          className="mobile-submenu-link"
                          onClick={() => setExpandedNavbar(false)}
                        >
                          {subItem.title}
                        </HashLink>
                      ))}
                    </div>
                  </div>
                ) : (
                  <Link
                    to={item.path}
                    className="mobile-link"
                    onClick={() => setExpandedNavbar(false)}
                  >
                    {item.title}
                  </Link>
                )}
              </div>
            ))}
          </div>
        </>
      )}
    </header>
  );
}

export default Navbar;
